module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-08-034c3828735ef857cc4afefbae94417a.svg";